import { PrinterConnectionComponent } from './printerconnection.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TypeaheadModule.forRoot(),
    TranslateModule.forChild({})
  ],
  declarations: [PrinterConnectionComponent],
  exports: [PrinterConnectionComponent]
})
export class PrinterConnectionModule {}
